export default {
  common: {
    projectList: "Liste des projets",
    pleaseInputProjectName: "Recherche de mots clés",
    pipeline: "Pipeline",
    onhold: "En attente",
    win: "Gagné",
    loss: "Perdu",
    city: "Ville",
    amount: "Montant",
    winProbability: "Probabilité de gain",
    registeredOn: "Enregistré le",
    updatedOn: "Mis à jour le",
    thereAreNoMoreProjectsLeft: "Il n'y a plus de projets restants",

    drafting: "Brouillon",
    ready: "Prêt",
    shared: "Partagé",
    negotiating: "Négociation",
    secured: "Sécurisé",
    lost: "Perdu",
    onhold: "En attente",

    INITIAL: "Préparation du rapport ECM",
    ECM_REPORT_PREPARED: "Rapport ECM en attente de partage avec le client",
    ECM_TO_CUSTOMER: "Rapport ECM envoyé au client",
    CUSTOMER_KIV_PROPOSAL: "Proposition gardée en vue par le client",
    CUSTOMER_FUNDED: "Le client a confirmé le financement du projet",
    CUSTOMER_PROPOSAL: "Le client négocie la proposition",
    EA_TO_CUSTOMER: "Rapport EA envoyé au client",
    CUSTOMER_ORDERS: "Commandes du client",
    LOST_TO_COMPETITION: "Perdu face à la concurrence",
    STATUS_PROJECT: "Statut rapporté dans un autre projet",
    IN_ACTIVE: "Projet en attente",
    getProjectInfoFailed: "Échec de l'obtention des informations du projet",
    getCitylistFailed: "Échec de l'obtention de la liste des villes",
    cantGetProjectDetails: "Impossible d'obtenir les détails du projet",
    noProjectId: "Aucun ID de projet",
    noProjectState: "Aucun état de projet",
    enterProjectName: "Saisissez le nom du projet",
    noActualEcmQuoted: "ECM réel non référencé",
    submitter: "Submitter",

    zone: "Zone",
    start: "commencer",
    end: "fin",
    clear: "Clear",
    search: "Recherche",

    details: "Détails",
    delete: "Supprimer",
    cancel: "Annuler",
    report: "Rapport",
    ok: "Ok",

    preRetrofitReport: "Rapport pré-rénovation",
    postRetrofitReport: "Rapport post-rénovation",
    downloadProjectReport: "Télécharger le rapport de projet",
    sureDelProject: "Êtes-vous sûr de supprimer ce projet ?",
    projectDetail: "Détails du projet",
    status: "Statut",
    confirm: "Confirmer",

    today: "Aujourd'hui",
    yesterday: "Hier",
    daysAgo: "jours il y a",
    resetLastDate: "Réinitialiser la dernière date",

    sure30days: "Êtes-vous sûr de n'avoir reçu aucune mise à jour au cours des 30 derniers jours?",
    resetUpdateToToday: "Réinitialiser la date de mise à jour à aujourd'hui",
    updateOrReset: "Réinitialiser",
    insufficientPermissions: "Permisos insuficientes",

    projectNotFound: "Projet non trouvé",
    sendToSFDC: "Envoyer à SFDC"
  },
  salesforce: {
    integrationStatus: "Statut de l'intégration Salesforce",
    leadNotApplicable: "Le statut du lead ne s'applique pas",
    leadTransferred: "Le lead a été transféré vers Salesforce",
    leadTransferFailed: "Échec du transfert du lead",
    opportunityNotApplicable: "Le statut de l'opportunité ne s'applique pas",
    opportunitySynchronized: "L'opportunité a été synchronisée avec Salesforce",
    opportunitySyncPending: "Synchronisation de l'opportunité en attente",
    opportunitySyncFailed: "Échec de la synchronisation de l'opportunité",
    lastSyncAttempt: "Dernière tentative de transfert de données : {date}",
    lastSynced: "Dernier transfert de données : {date}",
    lastAttempt: "Dernière Tentative : {date}",
    lastUpdate: "Dernière Mise à Jour : {date}",
    readyForSFDC: "Prêt pour SFDC",
    sentToSFDC: "Envoyé à SFDC",
    SFDCTransferFailed: "Échec du transfert vers SFDC",
    SendToSFDCOpportunityTitle: "Salesforce → iECM Spec Builder",
    SendToSFDCOpportunityDescription: "Envoyer l'opportunité à iECM pour analyse. Le rapport d'analyse finalisé est renvoyé à SFDC en un transfert unique.",
    SendToSFDCLeadTitle: "iECM Spec Builder → Salesforce",
    SendToSFDCLeadDescription: "Envoyer le lead à SFDC pour attribution à un commercial. Le lead entre dans le pipeline des leads afin d'être converti en opportunité, en un transfert unique."
  },
  projectDlg: {
    newProject: "Nouveau projet",
    projectName: "Nom du projet",
    projectState: "État du projet",
    customer: "Client",
    address: "Adresse",
    customerEmail: "E-mail du client",
    auditDate: "Date d'audit",
    jobsiteCity: "Ville du chantier",
    estimatedEcmQuoted: "Estimation du prix proposé pour l'ECM",
    exceptedOrder: "Date prévue de commande",
    winProbability: "Probabilité de gain (%)",
    saveRetrun: "Enregistrer & Retourner",
    saveAudit: "Enregistrer & Auditer",
    statusRemarks: "remarques",

    actualEcmQuoted: "Offres ECM réelles",
    actualOrder: "Date réelle de la commande",

    projectCreationMethod: "Méthode de création de projet",

    duplicate: "Copier le projet",
    manualInput: "Nouveau projet",
    duplicateFromOtherProject: "Utiliser un projet existant comme modèle",
    manuallyInputToCreateProject: "Commencer avec un projet vide",

    defaultValue: "Valeur par défaut",
    enterKeyDataUseDefaultValues: "Entrez une petite quantité de données clés et utilisez les valeurs par défaut pour créer un projet",
    copyFrom: "Dupliqué de",
    enterMoreInformation: "Entrez plus d'informations",
    pleaseSelectOne: "Veuillez sélectionner un",

    projectNameRequire: "'Nom du projet' est requis",
    duplicateFromRequire: "'Dupliquer de' est requis",

    stateIn1CantEditIn2: "Le statut de ce projet est gagné, perdu ou en attente dans le système 1.0, il ne prend donc pas en charge l'édition dans le système 2.0.",
    lastUpdateDate: "Date de la dernière mise à jour",

    intelligentInsightfulImpactful: "Mesures intelligentes d'efficacité énergétique",
    carriersSoftware: "iECM Spec Builder pour la rénovation des centrales de froid et de chauffage : créez un nouveau cahier des charges ou répondez à un cahier créé par d’autres.",
    intelligent: "Intelligent",
    intelligentDetails: "Créer un nouveau cahier des charges → proactif (créer l’opportunité), ou valider et traiter les exigences existantes → réactif (RFQ/appel d’offres).",
    insightful: "Pertinent",
    insightfulDetails: "Évaluez la conception selon les objectifs d’efficacité, définissez la régulation et appuyez-la par une garantie de performance.",
    impactful: "impactant",
    impactfulDetails: "Fournissez une proposition client et une alternative convaincante avec comparaisons d’efficacité, graphiques, ROI et délai de retour.",
    startNewAnalysis: "COMMENCER LA SPÉCIFICATION DE RÉNOVATION",

    reassignProject: "Réaffecter le projet",
    advancedSearch: "Recherche avancée",
    viewAuditData: "Afficher les données d'audit",

    customerID: "ID du client",
    copyFromSalesforce: "Copier depuis Salesforce"
  },

  downloadReportDlg: {
    retrofitSolution: "Solution de rénovation",
    proposal: "proposition",
    proposalUpper: "Proposition",
    autoConfig: "configuration automatique",
    userConfig: "configuration personnalisée"
  },

  wizardDlg: {
    quickAssessmentMode: "Évaluation rapide",
    quickAssessmentModeDetails: "Assistant guidé pour évaluer rapidement les opportunités",
    detailedAssessmentMode: "Évaluation détaillée",
    detailedAssessmentModeDetails: "Analyse complète pour une proposition client validée",
    title: "iECM"
  }
}



// WEBPACK FOOTER //
// ./src/locale/projectList/fr.js